import React from 'react';
import '../Shared/styles/shared.scss';

export default class LoadingSpinner extends React.PureComponent {
  render() {
    return (
      <div>
        <i className='spinner' />
      </div>
    );
  }
}
